<template>
 <div class="row mt-4 mb-2 font-weight-bold" style="font-size: 16px; text-decoration: underline;"> {{ $t('demand.tabs.features') }}</div>
        <div v-if="!orderConditions?.length" class="row">
            <label class="font-weight-bold">
                      {{ $t("order.orderConditions.NoConditionFound") }} 
            </label>
        </div>
         <div v-if="orderConditions?.length" class="row">
              <div v-for="(condition , index) in orderConditions" :key="condition.id">
                            <div :class="index>0 ? 'col-3 mb-1 ml-3' : 'col-3 mb-1'" >
                              <q-checkbox v-if="condition.checked"
                                v-model="condition.checked"
                                :label="$t('order.orderConditions.list.'+condition?.condition?.resourceUid)"
                                dense
                                disable
                                class="font-size-12"
                              />
                            </div>
                  </div>
          </div>                     
</template>

<script lang="ts">
import {Options, Vue} from "vue-class-component";


@Options({
   props: ["orderConditions"],
  components: {
  },
})
export default class summaryTabOrderFeatures extends Vue {
//isChecked :boolean = true
orderConditions?: Array<any>;}
</script>

<style scoped>
</style>
